import { Modal } from 'components/Modals';
import React, { useState } from 'react';
import {
  ModalContainer,
  ModalContainerActionBox,
  ModalContainerHeader,
  ModalContainerHeaderTitle,
  ModalContainerText,
} from './styles';
import Button from 'components/Button';
import MessageModal from 'common/MessageModal';
import { useLoading } from 'hooks/useLoading';
import EventService from 'services/EventService';
import BusinessService from 'services/TouristOffersBusinessService';
import { BusinessStatusAPI, IBusiness } from 'interfaces/IBusinesses';
import IEvent, { EventStatusAPI } from 'interfaces/IEvent';

interface DeleteSolicitationModalProps {
  isOpen: boolean;
  toggle: () => void;
  item: IBusiness | IEvent;
}

const DeleteSolicitationModal = ({ isOpen, toggle, item }: DeleteSolicitationModalProps): JSX.Element => {
  const { openLoading, closeLoading } = useLoading();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const service = {
    event: new EventService(),
    business: new BusinessService(),
  };

  const sendDeleteSolicitation = async () => {
    openLoading();
    try {
      openLoading();
      if ('type' in item) {
        await service.business.refuse(item.id);
        item.status = BusinessStatusAPI.REFUSED;
      } else {
        await service.event.refuse(item.id);
        item.status = EventStatusAPI.REFUSED;
      }

      setShowSuccessModal(true);
    } catch (error) {
      setShowErrorModal(true);
    }
    closeLoading();
  };

  const closeModal = () => {
    setShowSuccessModal(false);
    setShowErrorModal(false);
    toggle();
  };

  return (
    <>
      <MessageModal
        isOpen={showSuccessModal}
        title="Sucesso"
        message="Oferta turística recusada com sucesso!"
        onClose={closeModal}
      />
      <MessageModal
        isOpen={showErrorModal}
        title="Erro"
        message="Erro ao recusar oferta turística!"
        onClose={closeModal}
      />
      {!(showSuccessModal || showErrorModal) && (
        <Modal isOpen={isOpen} toggle={toggle}>
          <ModalContainer>
            <ModalContainerHeader>
              <ModalContainerHeaderTitle>Recusa de Oferta Turística</ModalContainerHeaderTitle>
            </ModalContainerHeader>
            <ModalContainerText>
              Você tem certeza de que deseja <b>recusar</b> essa oferta turística? Se continuar com a ação, {''}
              <b>não será possível desfazê-la</b>.
            </ModalContainerText>
            <ModalContainerActionBox>
              <Button buttonType="outline" className="cancel-button" onClick={toggle}>
                Cancelar
              </Button>
              <Button type="submit" disabled={false} onClick={sendDeleteSolicitation}>
                Recusar
              </Button>
            </ModalContainerActionBox>
          </ModalContainer>
        </Modal>
      )}
    </>
  );
};

export default DeleteSolicitationModal;
